module.exports = __webpack_public_path__ + "img/home.c48cbd19.svg";